/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_LearnInputs */

const en_withdrawal_learn = /** @type {(inputs: Withdrawal_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How the right of withdrawal works`)
};

const pl_withdrawal_learn = /** @type {(inputs: Withdrawal_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak działa prawo odstąpienia`)
};

/**
* | output |
* | --- |
* | "How the right of withdrawal works" |
*
* @param {Withdrawal_LearnInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_learn = /** @type {((inputs?: Withdrawal_LearnInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_LearnInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_learn(inputs)
	return en_withdrawal_learn(inputs)
});